module.exports = __webpack_public_path__ + "resources/right_icon.58dc8b36fcc06963.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/vote/component/vote-option-in-app/img/right_icon.png
// module id = 661
// module chunks = 0 1 2 3